import moment from 'moment';

export const columnsDataDevelopment = [
   {
      id: 'name',
      header: 'NAME',
      accessor: 'name',
   },
   {
      id: 'mobile',
      header: 'MOBILE',
      accessor: 'mobile',
   },
   {
      id: 'gst',
      header: 'GST',
      accessor: 'gst',
   },
   {
      id: 'city',
      header: 'CITY',
      accessor: 'city',
   },
   {
      id: 'ledger',
      header: 'LEDGER',
      accessor: 'ledger',
   },
   {
      id: 'balance',
      header: 'BALANCE',
      accessor: 'balance',
   },
];

export const columnsBankAccounts = [
   {
      id: 'name',
      header: 'NAME',
      accessor: 'name',
   },
   {
      id: 'address',
      header: 'ADDRESS',
      accessor: 'address',
   },
   {
      id: 'accno',
      header: 'ACC NO',
      accessor: 'accno',
   },
   {
      id: 'ifsc',
      header: 'IFSC CODE',
      accessor: 'ifsc',
   },
   {
      id: 'branch',
      header: 'BRANCH',
      accessor: 'branch',
   },
   // {
   //   id: 'city',
   //   header: 'CITY',
   //   accessor: 'city',
   // },
   {
      id: 'gst',
      header: 'GSTIN',
      accessor: 'gst',
   },
   // {
   //   id: 'state',
   //   header: 'STATE',
   //   accessor: 'state',
   // },
   {
      id: 'genledger',
      header: 'GENERAL LEDGER',
      accessor: 'genledger',
   },
   {
      id: 'bokercode',
      header: 'BROKER CODE',
      accessor: 'bokercode',
   },
   {
      id: 'type',
      header: 'TYPE',
      accessor: 'type',
   },
   {
      id: 'bal',
      header: 'BALANCE',
      accessor: 'balance',
   },
];

// export const columnsDataCustomerMaster = [
//   {
//     id: "name",
//     header: "NAME",
//     accessor: "name",
//   },
// {
//   id: "address",
//   header: "ADDRESS",
//   accessor: "address",
// },
//   {
//     id: "mobile",
//     header: "MOBILE",
//     accessor: "mobile",
//   },
//   {
//     id: "pan",
//     header: "PAN",
//     accessor: "pan",
//   },
// {
//   id: "billingadd",
//   header: "BILLING ADDRESS",
//   accessor: "billingadd",
// },
// {
//   id: "gst",
//   header: "GST",
//   accessor: "gst",
// },
// {
//   id: "city",
//   header: "CITY",
//   accessor: "city",
// },
// {
//   id: "state",
//   header: "STATE",
//   accessor: "state",
// },
// {
//   id: "country",
//   header: "COUNTRY",
//   accessor: "country",
// },
// {
//   id: "pin",
//   header: "PINCODE",
//   accessor: "pin",
// },
// {
//   id: "ledger",
//   header: "LEDGER",
//   accessor: "ledger",
// },
// {
//   id: "balance",
//   header: "BALANCE",
//   accessor: "balance",
// },
// ];
// export const columnsDataCustomerMaster = [
//   {
//     id: 'name',
//     header: 'NAME',
//     accessor: 'name',
//   },
//   // {
//   //   id: 'address',
//   //   header: 'ADDRESS',
//   //   accessor: 'address',
//   // },
//   {
//     id: 'mobile',
//     header: 'MOBILE',
//     accessor: 'mobile',
//   },
//   {
//     id: 'panNo',
//     header: 'PAN',
//     accessor: 'panNo',
//   },
//   {
//     id: 'email',
//     header: 'EMAIL',
//     accessor: 'email',
//   },
//   {
//     id: 'gst',
//     header: 'GST',
//     accessor: 'gst',
//   },
//   {
//     id: 'createdAt',
//     header: 'CREATED DATE',
//     accessor: 'createdAt',
//     cell: (info) => moment(info.getValue()).format('DD-MM-YYYY'),
//   },
//   // {
//   //   id: 'glGroupId',
//   //   header: 'GL GROUP ID',
//   //   accessor: 'glGroupId',
//   // },
//   {
//     id: 'city',
//     header: 'CITY',
//     accessor: 'city',
//   },
//   {
//     id: 'state',
//     header: 'STATE',
//     accessor: 'state',
//   },
//   {
//     id: 'country',
//     header: 'COUNTRY',
//     accessor: 'country',
//   },
//   {
//     id: 'pin',
//     header: 'PINCODE',
//     accessor: 'pin',
//   },
//   {
//     id: 'ledger',
//     header: 'LEDGER',
//     accessor: 'ledger',
//   },
//   {
//     id: 'balance',
//     header: 'BALANCE',
//     accessor: 'balance',
//   },
//   {
//     id: 'status',
//     header: 'STATUS',
//     accessor: 'status',
//     cell: (info) => <div>{info}</div>,
//   },
//   {
//     id: 'action',
//     header: 'ACTION',
//     accessor: 'action',
//     // cell: (info) => (
//     //   <Flex>
//     //     <Button
//     //       onClick={() => {
//     //       }}
//     //     >
//     //       <EditIcon />
//     //     </Button>
//     //     <Button
//     //       onClick={() => {
//     //       }}
//     //     >
//     //       <DeleteIcon />
//     //     </Button>
//     //   </Flex>
//     // ),
//   },
// ];
export const columnsItemDataDevelopment = [
   {
      id: 'name',
      header: 'NAME',
      accessor: 'name',
   },
   {
      id: 'barcode',
      header: 'BARCODE',
      accessor: 'barcode',
   },
   {
      id: 'itemGroupName',
      header: 'GROUP',
      accessor: 'itemGroupName',
   },
   {
      id: 'stock',
      header: 'Bal Qty 1',
      accessor: 'stock',
   },
   {
      id: 'uqc1Data',
      header: 'UQC 1',
      accessor: 'uqc1Data',
   },
   {
      id: 'uqc2Data',
      header: 'BAL QTY 2',
      accessor: 'uqc2Data',
   },
   {
      id: 'uqc3Data',
      header: 'BAL QTY 3',
      accessor: 'uqc3Data',
   },
   {
      id: 'primaryUqcData',
      header: 'PRIMARY (PCS)',
      accessor: 'primaryUqcData',
   },
   {
      id: 'sales',
      header: 'SALES REPORT',
      accessor: 'sales',
   },
   {
      id: 'purchasereport',
      header: 'PURCHASE REPORT',
      accessor: 'purchasereport',
   },
   {
      id: 'hsn',
      header: 'HSN',
      accessor: 'hsn',
   },
   {
      id: 'gstper',
      header: 'GST PERCENTAGE',
      accessor: 'gstper',
   },
];

export const columnsWarehouseDataDevelopment = [
   {
      id: 'name',
      header: 'NAME',
      accessor: 'name',
   },
   {
      id: 'shortName',
      header: 'SHORTNAME',
      accessor: 'shortName',
   },
   {
      id: 'aliasName',
      header: 'ALIASNAME',
      accessor: 'aliasName',
   },
   {
      id: 'code',
      header: 'Code',
      accessor: 'code',
   },
];

export const columnsCategoryDataDevelopment = [
   {
      id: 'name',
      header: 'NAME',
      accessor: 'name',
   },
   {
      id: 'ordinal',
      header: 'ORDINAL',
      accessor: 'ordinal',
   },
   {
      id: 'status',
      header: 'STATUS',
      accessor: 'status',
   },
   // {
   //   id: 'shortName',
   //   header: 'SHORTNAME',
   //   accessor: 'shortName',
   // },
   // {
   //   id: 'mobile',
   //   header: 'MOBILE',
   //   accessor: 'mobile',
   // },
];

export const columnsBrandDataDevelopment = [
   {
      id: 'name',
      header: 'NAME',
      accessor: 'name',
   },
   {
      id: 'printname',
      header: 'PRINT NAME',
      accessor: 'printname',
   },
   {
      id: 'ordinal',
      header: 'ORDINAL',
      accessor: 'ordinal',
   },
   {
      id: 'status',
      header: 'STATUS',
      accessor: 'status',
   },
   // {
   //   id: 'shortName',
   //   header: 'SHORTNAME',
   //   accessor: 'shortName',
   // },
   // {
   //   id: 'mobile',
   //   header: 'MOBILE',
   //   accessor: 'mobile',
   // },
];

export const columnsSeriesDataDevelopment = [
   {
      id: 'name',
      header: 'NAME',
      accessor: 'name',
   },
   {
      id: 'ordinal',
      header: 'ORDINAL',
      accessor: 'ordinal',
   },
   {
      id: 'brandname',
      header: 'BRAND',
      accessor: 'brandname',
   },
];

export const columnsModelDataDevelopment = [
   {
      id: 'name',
      header: 'NAME',
      accessor: 'name',
   },
   {
      id: 'ordinal',
      header: 'ORDINAL',
      accessor: 'ordinal',
   },
   {
      id: 'seriesname',
      header: 'SERIES',
      accessor: 'seriesname',
   },
   {
      id: 'color',
      header: 'COLOR',
      accessor: 'color',
   },
   {
      id: 'ram',
      header: 'RAM',
      accessor: 'ram',
   },
   {
      id: 'storage',
      header: 'STORAGE',
      accessor: 'storage',
   },
   {
      id: 'image',
      header: 'Image',
      accessor: 'image',
   },
];

export const columnsHsnDataDevelopment = [
   {
      id: 'hsn',
      header: 'HSN',
      accessor: 'hsn',
   },
   {
      id: 'hmApplyDate',
      header: 'APPLY DATE',
      accessor: 'hmApplyDate',
   },
   {
      id: 'gstType',
      header: 'GST TYPE',
      accessor: 'gstType',
   },
   {
      id: 'name',
      header: 'SubHsn Name',
      accessor: 'name',
   },
   {
      id: 'toRate',
      header: 'To Rate',
      accessor: 'toRate',
   },
   {
      id: 'fromRate',
      header: 'From Rate',
      accessor: 'fromRate',
   },
   {
      id: 'description',
      header: 'Description',
      accessor: 'description',
   },
];

export const columnsHsnSubDataDevelopment = [
   // {
   //   id: 'name',
   //   header: 'Name',
   //   accessor: 'name',
   // },
   {
      id: 'hsn',
      header: 'HSN',
      accessor: 'hsn',
   },
   {
      id: 'texgroupname',
      header: 'Tax Group',
      accessor: 'texgroupname',
   },
   {
      id: 'fromRate',
      header: 'FROM RATE',
      accessor: 'fromRate',
   },
   {
      id: 'toRate',
      header: 'TO RATE',
      accessor: 'toRate',
   },
   {
      id: 'applyDate',
      header: 'APPLY DATE',
      accessor: 'applyDate',
   },
];

export const columnsColorDataDevelopment = [
   {
      id: 'name',
      header: 'NAME',
      accessor: 'name',
   },
   {
      id: 'code',
      header: 'code',
      accessor: 'code',
   },
   {
      id: 'remarks',
      header: 'REMARKS',
      accessor: 'remarks',
   },
];

export const columnsPatternDataDevelopment = [
   {
      id: 'name',
      header: 'NAME',
      accessor: 'name',
   },
   {
      id: 'code',
      header: 'code',
      accessor: 'code',
   },
   {
      id: 'remarks',
      header: 'REMARKS',
      accessor: 'remarks',
   },
];

export const columnsCountByDataDevelopment = [
   {
      id: 'name',
      header: 'NAME',
      accessor: 'name',
   },
];

export const columnsDispatchByDataDevelopment = [
   {
      id: 'name',
      header: 'NAME',
      accessor: 'name',
   },
];

export const columnsItemGroupDataDevelopment = [
   {
      id: 'name',
      header: 'Name',
      accessor: 'name',
   },
   {
      id: 'itemgroupparentname',
      header: 'ParentId',
      accessor: 'itemgroupparentname',
   },
   {
      id: 'hsn',
      header: 'hsn',
      accessor: 'hsn',
   },
   {
      id: 'sac',
      header: 'sac',
      accessor: 'gstType',
   },
];

export const columnsDriverDataDevelopment = [
   {
      id: 'name',
      header: 'NAME',
      accessor: 'name',
   },
];

export const columnsCountryDataDevelopment = [
   {
      id: 'name',
      header: 'NAME',
      accessor: 'name',
   },
   {
      id: 'nationality',
      header: 'NATIONALITY',
      accessor: 'nationality',
   },
   {
      id: 'code',
      header: 'code',
      accessor: 'code',
   },
   {
      id: 'status',
      header: 'STATUS',
      accessor: 'status',
      cell: (info) => <div>{info}</div>,
   },
];

export const columnsStateDataDevelopment = [
   {
      id: 'name',
      header: 'NAME',
      accessor: 'name',
   },
   {
      id: 'country',
      header: 'COUNTRY',
      accessor: 'country',
   },
];

export const columnsCityDataDevelopment = [
   {
      id: 'name',
      header: 'NAME',
      accessor: 'name',
   },
   {
      id: 'country',
      header: 'COUNTRY',
      accessor: 'country',
   },
   {
      id: 'state',
      header: 'STATE',
      accessor: 'state',
   },
   {
      id: 'status',
      header: 'STATUS',
      accessor: 'status',
      cell: (info) => <div>{info}</div>,
   },
];

export const columnsAreaDataDevelopment = [
   {
      id: 'name',
      header: 'NAME',
      accessor: 'name',
   },
   {
      id: 'city',
      header: 'CITY',
      accessor: 'city',
   },
   {
      id: 'state',
      header: 'STATE',
      accessor: 'state',
   },
   // {
   //    id: 'country',
   //    header: 'COUNTRY',
   //    accessor: 'country',
   // },
   // {
   //    id: 'status',
   //    header: 'STATUS',
   //    accessor: 'status',
   //    cell: (info) => <div>{info}</div>,
   // },
];

export const columnsVehicleDataDevelopment = [
   {
      id: 'name',
      header: 'NAME',
      accessor: 'name',
   },
   {
      id: 'vehicleNo',
      header: 'VEHICLE NO',
      accessor: 'vehicleNo',
   },
];

export const columnsLedgerDataDevelopment = [
   {
      id: 'name',
      header: 'NAME',
      accessor: 'name',
   },
   {
      id: 'ordinalIndex',
      header: 'Original',
      accessor: 'ordinalIndex',
   },
];

export const columnsTransportDataDevelopment = [
   {
      id: 'name',
      header: 'NAME',
      accessor: 'name',
   },
   {
      id: 'email',
      header: 'EMAIL',
      accessor: 'email',
   },
   {
      id: 'mobile',
      header: 'MOBILE',
      accessor: 'mobile',
   },
];

export const columnsStyleDataDevelopment = [
   {
      id: 'name',
      header: 'NAME',
      accessor: 'name',
   },
   {
      id: 'notes',
      header: 'NOTES',
      accessor: 'notes',
   },
   {
      id: 'remarks',
      header: 'REMARKS',
      accessor: 'remarks',
   },
];

export const columnsSizeDataDevelopment = [
   {
      id: 'name',
      header: 'NAME',
      accessor: 'name',
   },
   {
      id: 'remarks',
      header: 'REMARKS',
      accessor: 'remarks',
   },
];

export const columnsGroupData = [
   {
      id: 'name',
      header: 'NAME',
      accessor: 'name',
   },
   {
      id: 'parent',
      header: 'PARENT',
      accessor: 'parent',
   },
   {
      id: 'status',
      header: 'STATUS',
      accessor: 'status',
   },
   {
      id: 'notes',
      header: 'NOTES',
      accessor: 'notes',
   },
   {
      id: 'hsn',
      header: 'HSN',
      accessor: 'hsn',
   },
   {
      id: 'sac',
      header: 'SAC',
      accessor: 'sac',
   },
];

export const columnsUnitData = [
   {
      id: 'name',
      header: 'NAME',
      accessor: 'name',
   },
   {
      id: 'uom',
      header: 'UOM',
      accessor: 'uom',
   },
   {
      id: 'status',
      header: 'STATUS',
      accessor: 'status',
   },
];

export const columnsJournalVoucherColumn = [
   { id: 'docNumber', header: 'Doc No', accessor: 'docNumber' },
   { id: 'txnDate', header: 'Date', accessor: 'txnDate' },
   { id: 'daybookname', header: 'Type', accessor: 'daybookname' },
   {
      id: 'notes',
      header: 'NOTES',
      accessor: 'notes',
   },
   {
      id: 'total_amount',
      header: 'AMOUNT',
      accessor: 'total_amount',
   },
];

export const columnsScreenData = [
   {
      id: 'name',
      header: 'SCREEN NAME',
      accessor: 'name',
   },
   // {
   //    id: 'itemname',
   //    header: 'ITEM NAME',
   //    accessor: 'itemname',
   // },
   {
      id: 'cut',
      header: 'CUT',
      accessor: 'cut',
   },
   {
      id: 'itemRate',
      header: 'RATE',
      accessor: 'itemRate',
   },
   {
      id: 'notes',
      header: 'Notes',
      accessor: 'notes',
   },
   {
      id: 'status',
      header: 'STATUS',
      accessor: 'status',
   },
   // {
   //    id: 'colour',
   //    header: 'COLOUR',
   //    accessor: 'colour',
   // },
   // {
   //    id: 'weight',
   //    header: 'WEIGHT',
   //    accessor: 'weight',
   // },
];

export const columnsBillTermData = [
   {
      id: 'signname',
      header: 'SIGN',
      accessor: 'signname',
   },
   {
      id: 'daybookname',
      header: 'DAYBOOK',
      accessor: 'daybookname',
   },
   {
      id: 'accountname',
      header: 'ACCOUNT',
      accessor: 'accountname',
   },
   {
      id: 'code',
      header: 'CODE',
      accessor: 'code',
   },
   {
      id: 'methodOfCalcName',
      header: 'METHOD OF CALCULATION',
      accessor: 'methodOfCalcName',
   },
   {
      id: 'formula',
      header: 'FORMULA',
      accessor: 'formula',
   },
   {
      id: 'description',
      header: 'DESCRIPTION',
      accessor: 'description',
   },
];

// export const columnsDataDevelopment = [
//   {
//     header: "NAME",
//     accessor: "name",
//   },
//   {
//     header: "TECH",
//     accessor: "tech",
//   },
//   {
//     header: "DATE",
//     accessor: "date",
//   },
//   {
//     header: "PROGRESS",
//     accessor: "progress",
//   },
// ];

export const columnsDataCheck = [
   {
      header: 'NAME',
      accessor: 'name',
   },
   {
      header: 'PROGRESS',
      accessor: 'progress',
   },
   {
      header: 'QUANTITY',
      accessor: 'quantity',
   },
   {
      header: 'DATE',
      accessor: 'date',
   },
];

export const columnsDataColumns = [
   {
      header: 'NAME',
      accessor: 'name',
   },
   {
      header: 'PROGRESS',
      accessor: 'progress',
   },
   {
      header: 'QUANTITY',
      accessor: 'quantity',
   },
   {
      header: 'DATE',
      accessor: 'date',
   },
];

export const columnsDataComplex = [
   {
      header: 'NAME',
      accessor: 'name',
   },
   {
      header: 'STATUS',
      accessor: 'status',
   },
   {
      header: 'DATE',
      accessor: 'date',
   },
   {
      header: 'PROGRESS',
      accessor: 'progress',
   },
];

export const daybookColumns = [
   {
      id: 'name',
      header: 'NAME',
      accessor: 'name',
   },
   {
      id: 'typeName',
      header: 'TYPE',
      accessor: 'typeName',
   },
   {
      id: 'subTypeName',
      header: 'SUB TYPE',
      accessor: 'subTypeName',
   },
   {
      id: 'accountNo',
      header: 'ACCOUNT NO',
      accessor: 'accountNo',
   },
   {
      id: 'account_name',
      header: 'ACCOUNT NAME',
      accessor: 'account_name',
   },
   {
      id: 'termsNConditions',
      header: 'TERMS CONDITIONS',
      accessor: 'termsNConditions',
   },
   {
      id: 'autoRoundOffAtName',
      header: 'AUTO ROUND OFF AT',
      accessor: 'autoRoundOffAtName',
   },
   {
      id: 'methodOfRoundLIName',
      header: 'METHOD OF ROUND LI',
      accessor: 'methodOfRoundLIName',
   },
   // {
   //   id: 'issueFieldRegion',
   //   header: 'ISSUE FIELD REGION',
   //   accessor: 'issueFieldRegion',
   // },
   {
      id: 'issuedaybookname',
      header: 'ISSUE DAYBOOK NAME',
      accessor: 'issuedaybookname',
   },
   {
      id: 'isOld',
      header: 'IS OLD',
      accessorKey: 'isOld',
   },
   {
      id: 'status',
      header: 'STATUS',
      accessor: 'status',
   },
];

export const columnsSalesRepresentativeDataDevelopment = [
   {
      id: 'name',
      header: 'NAME',
      accessor: 'name',
   },
   {
      id: 'mobile',
      header: 'MOBILE',
      accessor: 'mobile',
   },
];

export const columnsReportsSalesDetail = [
   {
      id: 'transactionAt',
      header: 'Date',
      accessor: 'transactionAt',
      cell: (info) => {
         const value = info.getValue();
         return value ? moment(value).format('DD-MM-YYYY') : '';
      },
   },
   {
      id: 'docno',
      header: 'Doc#',
      accessor: 'docno',
   },
   {
      id: 'accountname',
      header: 'Party',
      accessor: 'accountname',
   },
   {
      id: 'daybookname',
      header: 'Daybook',
      accessor: 'daybookname',
   },
   {
      id: 'mobile',
      header: 'Mobile',
      accessor: 'mobile',
   },
   {
      id: 'brokername',
      header: 'Broker',
      accessor: 'brokername',
   },
   {
      id: 'salesmanname',
      header: 'Salesman',
      accessor: 'salesmanname',
   },
   {
      id: 'notes',
      header: 'Notes',
      accessor: 'notes',
   },
   {
      id: 'totalQty1',
      header: 'Qty',
      accessor: 'totalQty1',
   },
   {
      id: 'netAmount',
      header: 'Net Amount',
      accessor: 'netAmount',
   },
];

export const columnsglobalIMEI = [
   {
      id: 'imeiNo',
      header: 'imeiNo',
      accessor: 'imeiNo',
   },
   {
      id: 'createdAt',
      header: 'created At',
      accessor: 'createdAt',
   },
];

export const columnsReportsPurchaseDetail = [
   {
      id: 'date',
      header: 'Date',
      accessor: 'date',
   },
   {
      id: 'docnumber',
      header: 'Doc No',
      accessor: 'docnumber',
   },
   {
      id: 'daybookname',
      header: 'Daybook',
      accessor: 'daybookname',
   },
   {
      id: 'daybookaccountname',
      header: 'ContraAccount',
      accessor: 'daybookaccountname',
   },
   {
      id: 'particulars',
      header: 'Particulars',
      accessor: 'particulars',
   },
   {
      id: 'accountname',
      header: 'Contact',
      accessor: 'accountname',
   },
   {
      id: 'transactionAt',
      header: 'TransactionAt',
      accessor: 'transactionAt',
   },
];

export const columnsReportsOutstandingDetail = [
   {
      id: 'accountname',
      header: 'Contact',
      accessor: 'accountname',
   },
   {
      id: 'docno',
      header: 'Doc No',
      accessor: 'docno',
   },
   {
      id: 'transactionAt',
      header: 'TransactionAt',
      accessor: 'transactionAt',
   },
];
export const columnsReportsGstr1Detail = [
   {
      id: 'accountname',
      header: 'Contact',
      accessor: 'accountname',
   },
   {
      id: 'docno',
      header: 'Doc No',
      accessor: 'docno',
   },
   {
      id: 'transactionAt',
      header: 'TransactionAt',
      accessor: 'transactionAt',
   },
];
export const columnsReportsGstr2Detail = [
   {
      id: 'accountname',
      header: 'Contact',
      accessor: 'accountname',
   },
   {
      id: 'docno',
      header: 'Doc No',
      accessor: 'docno',
   },
   {
      id: 'transactionAt',
      header: 'TransactionAt',
      accessor: 'transactionAt',
   },
];